


























import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'

@Component
export default class InputMoney extends Vue {
    @Prop({ type: String }) readonly vid!: string
    @Prop({ type: Boolean, default: false }) readonly notNullable!: boolean
    @Prop({ type: Boolean, default: false }) readonly trim!: boolean
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
    @Prop({ type: Boolean, default: false }) readonly readonly!: boolean
    @Prop({ type: String, default: 'text' }) readonly type!: string
    @Prop({ type: String, default: 'text' }) readonly inputmode!: string
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    @Prop() readonly textLeft!: string
    @Prop() readonly textRight!: string
    @Prop() readonly clickLeft!: () => void
    @Prop() readonly clickRight!: () => void
    @Prop() readonly step!: string
    @Prop({ default: 2 }) readonly precision!: number
    internalValue: string = null
    focus: boolean = false

    created() {
        this.onExternalChange()
    }

    transformInput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    transformOutput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = ''
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        if (this.notNullable === false && typeof this.internalValue === 'string' && this.internalValue.length === 0) {
            this.internalValue = null
        }

        const value = this.transformOutput(this.internalValue)
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    onFocus(): void {
        this.focus = true
    }

    onBlur(): void {
        this.focus = false
    }

    get inputListeners() {
        return Object.assign({}, this.$listeners, {
            input: this.onInput,
            focus: this.onFocus,
            blur: this.onBlur,
        })
    }

    get componentClass(): object {
        return {
            'input-text': true,
            'bd-round-outline': true,
            'input-text--focussed': this.focus,
            'input-text--disabled': this.disabled,
        }
    }

    get componentStyle(): object {
        const widths = ['1fr']

        if (this.textLeft) {
            widths.unshift('auto')
        }

        if (this.textRight) {
            widths.push('auto')
        }

        return {'grid-template-columns': widths.join(' ')}
    }

    get mask(): object {
        return {
            decimal: ',',
            thousands: '.',
            precision: this.precision,
            masked: false,
        }
    }
}
